import React from "react";
import DoneIcon from "Assets/Icons/DoneIcon.png";
import CustomModal from "Components/Modal/CustomModal";

const ThankYouModalForCallBack = ({ show, handleCloseModal }) => {
  return (
    <CustomModal
      removeHeader
      size={"md"}
      show={show}
      remove
      onClose={handleCloseModal}
    >
      <div className="">
        <div className="container">
          <div className="row ">
            <div className="col-12">
              <div className="get-a-callback-wrapper">
                <div className="d-flex justify-content-center">
                  <img alt="Thank You" className="" src={DoneIcon} />
                </div>
                <h3 className="d-flex  mt-4 justify-content-center">
                  Thank You
                </h3>

                <h6 className="d-flex justify-content-center mt-4 text-center">
                  We will get back to you Soon
                </h6>

                <div class="form-group submit mt-4 d-flex justify-content-center">
                  <button
                    type="submit"
                    onClick={handleCloseModal}
                    class="btn btn-md"
                  >
                    <span> Okay</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};
export default ThankYouModalForCallBack;
